<template>
  <a-drawer
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    v-model:open="open"
    @close="onClose"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form ref="formRef" :model="form" :rules="rules">
      <!--      <a-form-model-item label="用户id" prop="userId" >-->
      <!--        <a-input v-model="form.userId" placeholder="请输入用户id" />-->
      <!--      </a-form-model-item>-->
      <!--      <a-form-model-item label="店铺id" prop="shopId" >-->
      <!--        <a-input v-model="form.shopId" placeholder="请输入店铺id" />-->
      <!--      </a-form-model-item>-->
      <a-form-item label="提现金额" name="money">
        <a-input
          v-model:value="form.money"
          disabled
          placeholder="请输入提现金额"
        />
      </a-form-item>
      <a-form-item label="提现手续费" name="serviceChargeNum">
        <a-input
          v-model:value="form.serviceChargeNum"
          disabled
          placeholder="请输入提现手续费"
        />
      </a-form-item>
      <a-form-item label="实际需要转账金额" name="realMoney">
        <a-input
          v-model:value="form.realMoney"
          disabled
          placeholder="请输入实际需要转账金额"
        />
      </a-form-item>
      <!--      <a-form-model-item label="0-余额 1-保证金" prop="type" >-->
      <!--      </a-form-model-item>-->

      <a-form-item label="提现方式" name="withdrawType">
        <a-select
          v-model:value="form.withdrawType"
          placeholder="请选择提现方式"
          disabled
        >
          <a-select-option key="1">支付宝</a-select-option>
          <a-select-option key="2">微信</a-select-option>
          <a-select-option key="3">银行</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item
        label="提现账号"
        name="accountNum"
        v-if="form.withdrawType == 1 || form.withdrawType == 2"
      >
        <a-input
          v-model:value="form.accountNum"
          disabled
          placeholder="请输入提现账号"
        />
      </a-form-item>
      <a-form-item
        label="提现账号姓名"
        name="accountName"
        v-if="form.withdrawType == 1 || form.withdrawType == 2"
      >
        <a-input
          v-model:value="form.accountName"
          disabled
          placeholder="请输入提现账号姓名"
        />
      </a-form-item>

      <a-form-item
        label="银行卡号"
        name="accountNum"
        v-if="form.withdrawType == 3"
      >
        <a-input
          v-model:value="form.accountNum"
          disabled
          placeholder="请输入提现账号"
        />
      </a-form-item>
      <a-form-item
        label="银行名称"
        name="bankName"
        v-if="form.withdrawType == 3"
      >
        <a-input
          v-model:value="form.bankName"
          disabled
          placeholder="请输入银行名称"
        />
      </a-form-item>
      <a-form-item
        label="银行卡开户行地址"
        name="bankAdress"
        v-if="form.withdrawType == 3"
      >
        <a-input
          v-model:value="form.bankAdress"
          disabled
          placeholder="请输入银行卡开户行地址"
        />
      </a-form-item>

      <!--      <a-form-model-item label="1：普通用户" prop="withdrawUserType" >-->
      <!--      </a-form-model-item>-->
      <!--      <a-form-model-item label="第三方订单号(微信或支付的交易单号)" prop="orderNo" >-->
      <!--        <a-input v-model="form.orderNo" placeholder="请输入第三方订单号(微信或支付的交易单号)" />-->
      <!--      </a-form-model-item>-->
      <!--      <a-form-model-item label="失败原因" prop="failureReason" >-->
      <!--        <a-input v-model="form.failureReason" placeholder="请输入失败原因" />-->
      <!--      </a-form-model-item>-->
      <a-form-item label="审核状态" name="status">
        <a-select v-model:value="form.status" placeholder="请选择审核状态">
          <!--          <a-select-option key="0">待审核</a-select-option>-->
          <a-select-option key="1">审核驳回</a-select-option>
          <a-select-option key="2">审核通过</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item
        label="审核意见"
        name="auditOpinion"
        v-if="form.status == '1'"
      >
        <a-input
          v-model:value="form.auditOpinion"
          placeholder="请输入审核意见"
        />
      </a-form-item>
      <!--      <a-form-model-item label="收款二维码" prop="qrCode" >-->
      <!--        <a-input v-model="form.qrCode" placeholder="请输入收款二维码" />-->
      <!--      </a-form-model-item>-->

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form>
  </a-drawer>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { $emit } from '../../../../utils/gogocodeTransfer'
import { getWithdrawal, addWithdrawal, updateWithdrawal } from '@/api/user/withdrawal'

defineOptions({
  name: 'CreateForm',
})

defineProps({})
const emit = defineEmits(['ok'])

const formRef = ref()
const submitLoading = ref(false)
const formTitle = ref('')
const formType = ref(1)
const open = ref(false)

const form = reactive({
  id: null,
  userId: null,
  shopId: null,
  money: null,
  realMoney: null,
  type: null,
  status: '0',
  accountNum: null,
  accountName: null,
  serviceChargeNum: null,
  withdrawType: null,
  withdrawUserType: null,
  orderNo: null,
  failureReason: null,
  auditOpinion: null,
  qrCode: null,
  bankName: null,
  bankAdress: null,
  createTime: null,
})

const rules = {}

function onClose() {
  open.value = false
}

function cancel() {
  open.value = false
  reset()
}

function reset() {
  formType.value = 1
  Object.assign(form, {
    id: null,
    userId: null,
    shopId: null,
    money: null,
    realMoney: null,
    type: null,
    status: '0',
    accountNum: null,
    accountName: null,
    serviceChargeNum: null,
    withdrawType: null,
    withdrawUserType: null,
    orderNo: null,
    failureReason: null,
    auditOpinion: null,
    qrCode: null,
    bankName: null,
    bankAdress: null,
    createTime: null,
  })
}

function handleAdd() {
  reset()
  formType.value = 1
  open.value = true
  formTitle.value = '添加'
}

function handleUpdate(row, ids) {
  reset()
  formType.value = 2
  const id = row ? row.id : ids
  getWithdrawal({ id }).then((response) => {
    Object.assign(form, response.data || {})
    form.status = '2'
    open.value = true
    formTitle.value = '审核'
  })
}

function submitForm() {
  formRef.value?.validate().then((valid) => {
    if (!valid) return
    submitLoading.value = true
    const req = form.id !== undefined && form.id !== null ? updateWithdrawal(form) : addWithdrawal(form)
    req
      .then(() => {
        window.$message?.success?.(form.id ? '修改成功' : '新增成功', 3)
        open.value = false
        $emit(this, 'ok')
      })
      .finally(() => {
        submitLoading.value = false
      })
  })
}
</script>
